(function () {
    function init(root) {
      if (!root || root.dataset.ccInit === "true") return;
      root.dataset.ccInit = "true";

      const track = root.querySelector("[data-cc-track]");
      if (!track) return;

      const btnPrev = root.querySelector("[data-cc-prev]");
      const btnNext = root.querySelector("[data-cc-next]");

      // Measure only the track's direct slides so wrappers and inner cards
      // don't get double-counted as separate items.
      const items = Array.from(track.children).filter((item) => item.nodeType === 1);

      if (!items.length) return;

      // Step size = viewport width minus a small peek
      function getStep() {
        return Math.max(80, track.clientWidth - 80);
      }

      function scrollByStep(dir = 1) {
        track.scrollBy({ left: dir * getStep(), behavior: "smooth" });
      }
  
      // Arrows
      if (btnPrev) btnPrev.addEventListener("click", (evt) => {
        evt.stopPropagation();
        scrollByStep(-1);
      });
      if (btnNext) btnNext.addEventListener("click", (evt) => {
        evt.stopPropagation();
        scrollByStep(1);
      });

      function updateArrowVisibility() {
        const firstItem = items[0];
        const lastItem = items[items.length - 1];

        if (!firstItem || !lastItem) return;

        const trackStyles = window.getComputedStyle(track);
        const paddingLeft = parseFloat(trackStyles.paddingLeft) || 0;
        const paddingRight = parseFloat(trackStyles.paddingRight) || 0;
        const viewportLeft = track.scrollLeft + paddingLeft;
        const viewportRight = track.scrollLeft + track.clientWidth - paddingRight;
        const contentStart = firstItem.offsetLeft;
        const contentEnd = lastItem.offsetLeft + lastItem.offsetWidth;
        const tolerance = 2;
        const hasOverflow = contentEnd - contentStart > viewportRight - viewportLeft + tolerance;
        const atStart = contentStart >= viewportLeft - tolerance;
        const atEnd = contentEnd <= viewportRight + tolerance;

        if (btnPrev) {
          btnPrev.hidden = !hasOverflow || atStart;
          btnPrev.setAttribute("aria-hidden", String(btnPrev.hidden));
          btnPrev.style.display = btnPrev.hidden ? "none" : "";
        }

        if (btnNext) {
          btnNext.hidden = !hasOverflow || atEnd;
          btnNext.setAttribute("aria-hidden", String(btnNext.hidden));
          btnNext.style.display = btnNext.hidden ? "none" : "";
        }
      }

      let rafId = null;
      function queueArrowVisibilityUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(() => {
          rafId = null;
          updateArrowVisibility();
        });
      }
  
      // Keyboard on track
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") { e.preventDefault(); scrollByStep(-1); }
        if (e.key === "ArrowRight") { e.preventDefault(); scrollByStep(1); }
      });

      track.addEventListener("scroll", queueArrowVisibilityUpdate, { passive: true });
      window.addEventListener("resize", queueArrowVisibilityUpdate);

      if ("ResizeObserver" in window) {
        const resizeObserver = new ResizeObserver(queueArrowVisibilityUpdate);
        resizeObserver.observe(track);
        items.forEach((item) => resizeObserver.observe(item));
      }

      queueArrowVisibilityUpdate();
    }
  
    function boot() {
      const carousels = document.querySelectorAll("[data-cc]");
      carousels.forEach(init);
    }

    // Expose for manual calls (e.g., after dynamic section render)
    window.cardCarouselBoot = boot;
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }

    // Re-run on Shopify section loads in editor or dynamic renders
    document.addEventListener("shopify:section:load", (event) => {
      const target = event.target;
      const carousels = target?.querySelectorAll?.("[data-cc]") || [];
      carousels.forEach(init);
    });

    document.addEventListener("shopify:section:select", (event) => {
      const target = event.target;
      const carousels = target?.querySelectorAll?.("[data-cc]") || [];
      carousels.forEach(init);
    });
  })();
  
